import {
  generalTerm,
} from '@/constants/locales/en.shared.ts';

export default {
  tabMenu: {
    view: 'Układ',
    alarm: 'Alarmy',
    loadList: 'Załaduj listę',
    recipe: generalTerm.recipe,
  },
};
